import type { SupabaseSession } from "../api/auth";

// Persistência da sessão — decisão desta etapa: sessionStorage, não localStorage. Dado institucional,
// sem pedido de "lembrar de mim"; a sessão cai ao fechar a aba/navegador, reduzindo exposição em
// computador compartilhado. Nada aqui é lido/gravado em tabela Supabase — é só o token que a Edge
// Function já validou.
const STORAGE_KEY = "iedc-associados.session";

export interface StoredSession {
  session: SupabaseSession;
  memberId: string | null;
  username: string;
  requiresPasswordChange: boolean;
  requiresMfaEnrollment: boolean;
}

function isExpired(session: SupabaseSession): boolean {
  if (!session.expires_at) return false;
  return session.expires_at * 1000 <= Date.now();
}

export function loadSession(): StoredSession | null {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as StoredSession;
    if (isExpired(parsed.session)) {
      clearSession();
      return null;
    }
    return parsed;
  } catch {
    clearSession();
    return null;
  }
}

export function saveSession(stored: StoredSession): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
}

export function clearSession(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
